"use client";
import { useSyncExternalStore } from "react";

/**
 * SSR-safe matchMedia hook via useSyncExternalStore.
 * Replaces window.innerWidth probes in JS (spec §6.4 — media queries allowed,
 * window.innerWidth forbidden).
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", cb);
      return () => mql.removeEventListener("change", cb);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
